import { combineReducers } from "redux";
import { flightReducer } from "../reducers/flightReducer";
import { commonReducer } from "../reducers/commonReducer";
import { tourReducer } from "../reducers/tourReducer";
export default combineReducers(
  {
    flights: flightReducer,
    common: commonReducer,
    tours: tourReducer
  },
);
